import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import Loading from 'src/components/Loading/Loading'
import { TOTP } from 'otpauth'
import { useUserActions } from 'src/hooks/api'
import { getUserSecret, removeUserSecret } from 'src/utils/helper'

import './Login.sass'

declare const window: any

const Login = () => {
  const navigate = useNavigate()
  const [status, setStatus] = useState('')
  const { state } = useLocation()
  const { login } = useUserActions()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (status === 'loading') return
    const email = e.target.username.value
    const password = e.target.password.value
    const secret = getUserSecret(email)
    setStatus('loading')

    // TODO CHange
    login(
      secret
        ? { email, password, associationRequest: false, code: new TOTP({ secret }).generate() }
        : { email, password, associationRequest: true }
    )
      .then((data) => {
        try {
          window.gtag?.('event', 'login', { id: data.id })
          window.fcmSubscribe && window.fcmSubscribe()
        } catch (err) {
          console.info(err)
        }
        if (state.back) {
          navigate(state.back, { replace: true })
        }
      })
      .catch((err) => {
        if (
          err.status === 401 &&
          err.payload.message === 'Code not informed, email sent'
        ) {
          setStatus('missing-secret')
        } else if (
          err.status === 401 &&
          err.payload.message === 'Invalid secret'
        ) {
          setStatus('invalid-secret')
          removeUserSecret(email)
        } else {
          setStatus('error')
        }
      })
  }

  const loginForm = (
    <form onSubmit={handleSubmit} className={status}>
      <label>
        <span className="icon icon-mail" />
        <FormattedMessage id="placeholder.email">
          {(text: string) => (
            <input
              type="email"
              name="username"
              required
              placeholder={text}
              autoComplete="email"
            />
          )}
        </FormattedMessage>
      </label>
      <label>
        <span className="icon icon-lock" />
        <FormattedMessage id="placeholder.password">
          {(text: string) => (
            <input
              type="password"
              name="password"
              required
              placeholder={text}
              autoComplete="password"
            />
          )}
        </FormattedMessage>
      </label>
      <p className={`error-message ${status}`}>
        {status === 'error' && (
          <span>
            <FormattedMessage id="login.error" />
          </span>
        )}
        {status === 'error-403' && (
          <span>
            <FormattedMessage id="login.error-403" />
          </span>
        )}
        {status === 'error-secret' && (
          <span>
            <FormattedMessage id="login.error-secret" />
          </span>
        )}
      </p>
      <p className="contact">
        <Link to="recover">
          <MarkdownMessage id="login.forgot-password" />
        </Link>
      </p>
      <button className="filled" type="submit">
        <FormattedMessage id="login" />
      </button>
    </form>
  )

  const missingSecret = (
    <>
      <p className="no-secret">
        <FormattedMessage id="login.see-email" />
      </p>
      <p className="remind">
        <FormattedMessage id="login.remind" />
      </p>
      <button className="filled" onClick={() => setStatus('')}>
        <FormattedMessage id="comeback" />
      </button>
    </>
  )

  const invalidSecret = (
    <>
      <p className="invalid-secret">
        <FormattedMessage id="login.re-pair-client-no-association" />
      </p>
      <p className="remind">
        <FormattedMessage id="login.re-pair-client-info" />
      </p>
      <button className="filled" onClick={() => setStatus('')}>
        <FormattedMessage id="comeback" />
      </button>
    </>
  )

  return (
    <div id="login" className="page split">
      <header className="item left" id="login-header" />
      <section className="item right" id="login-content">
        <div className="wrapper">
          <img src="images/logo.png" alt="logo" />
          <div className="login-form">
            <h2>
              <FormattedMessage id="login.title" />
            </h2>
            {status === 'loading' ? (
              <Loading />
            ) : status === 'missing-secret' ? (
              missingSecret
            ) : status === 'invalid-secret' ? (
              invalidSecret
            ) : (
              loginForm
            )}
          </div>
          <h4>
            <Link className="register-link" to="register">
              <MarkdownMessage id="login.no-account" />
            </Link>
          </h4>
        </div>
      </section>
    </div>
  )
}

export default Login
